export default __webpack_public_path__ + "static/feature-1-224e6b4bd46ca3b0a256ba1a14b3314e.png";